import { useNavigate } from "react-router-dom";
import { Lock, ArrowLeft, Mail } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const FeatureGate = ({ featureName, featureLabel }) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <div className="mx-auto w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
            <Lock className="h-8 w-8 text-amber-600" />
          </div>
          <CardTitle className="text-xl">Feature Not Available</CardTitle>
          <CardDescription className="text-base">
            {featureLabel || featureName} is not enabled for your account
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            This feature requires a subscription upgrade or administrator approval. 
            Contact your administrator to enable access.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button variant="outline" onClick={() => navigate(-1)}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            </Button>
            <Button variant="outline" onClick={() => navigate("/")}>
              Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export const withFeatureGate = (WrappedComponent, featureName, featureLabel) => {
  return function FeatureGatedComponent({ user, ...props }) {
    const isAdmin = user?.is_admin === true;
    const featureFlags = user?.feature_flags || {};
    const hasFeature = isAdmin || featureFlags[featureName] === true;
    
    if (!hasFeature) {
      return <FeatureGate featureName={featureName} featureLabel={featureLabel} />;
    }
    
    return <WrappedComponent user={user} {...props} />;
  };
};

export default FeatureGate;
